// quickFindStore.ts — Estado global do QuickFind
// Permite que qualquer componente abra o QuickFind com query pré-preenchida

import { create } from 'zustand';

interface QuickFindState {
  isOpen: boolean;
  initialQuery: string | undefined;
  open: (query?: string) => void;
  close: () => void;
}

export const useQuickFindStore = create<QuickFindState>((set) => ({
  isOpen: false,
  initialQuery: undefined,
  open: (query?: string) => set({ isOpen: true, initialQuery: query }),
  close: () => set({ isOpen: false, initialQuery: undefined }),
}));
